<template>
  <div>
    <!--INÍCIO NAV DESKTOP -->
    <nav class="navbar-expand-lg fixed-top navbar-light bg-light menu-md">
   
        <div class="row">
          <div class="col-sm">
            <ul class="navbar-nav mr-auto">    
              <li class="menu-esq nav-item dropdown">
              <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" id="navbarDropdown" aria-haspopup="true" aria-expanded="false">
                <img src="../assets/icons/icon-material-menu.png" class="img-fluid">
              </a>
                <div class="dropdown-menu" id="menuHome" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" v-on:click="home()" href="" >Home</a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#leb">Leb</a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#destaques">Destaques da obra</a>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#autoras">Autora</a>
                </div>
              </li>  
            </ul>
          </div>          
          <div class="col-sm text-center">
             <img src="../assets/logos/logo-tic-tac.png" class="img-fluid">  
             <img src="../assets/logos/selo.png" class="img-selo">      
          </div>
          <div class="col-sm">
              <div class="float-right">
                  <ul class="navbar-nav">
                      <li class="nav-item login">
                          <a class="nav-link" target="_blank" href="https://editoradobrasil.com.br/leb/login">LOGIN</a>
                      </li>
                      <li class="nav-item">
                          <a class="btn btn-laranja" target="_blank" href="https://www.editoradobrasil.com.br/sistemas/cadastro">Cadastre-se</a>
                      </li>
                  </ul>
              </div>
            </div>
        </div>
    
    </nav>
    <!--FIM NAV DESKTOP -->

    <!--INÍCIO NAV MOBILE -->
    <nav class="fixed-top navbar-light bg-light menu-sm mobile"> 
      <div class="row">
          <div class="col-3 menu-material">
              <button class="navbar-toggler hamb" type="button" data-toggle="collapse" data-target="#menu-mb" aria-controls="menu-mb" aria-expanded="false" aria-label="Toggle navigation">
                  <img src="../assets/icons/icon-material-menu.png" class="img-fluid">
              </button>
          </div>
          <div class="col-5 logo-mobile">
            <img src="../assets/logos/logo-tic-tac.png" class="img-fluid">                  
          </div>
          <div class="col login-mobile text-right">
            <button class="navbar-toggler login" type="button" data-toggle="collapse" data-target="#menu-login" aria-controls="menu-login" aria-expanded="false" aria-label="Toggle navigation">
              <img src="../assets/icons/login.png" class="img-fluid">
            </button>
          </div>
      </div>
      <div class="row menu-escondido">
          <div class="col">
              <div class="collapse navbar-collapse navbar-left" id="menu-mb">
                  <ul class="navbar-nav mr-auto line-mobile">
                      <div class="menu bold">Menu</div>                         
                      <li class="nav-item" >
                        <a class="dropdown-item bold" v-on:click="removeClass()" href="#home">Home</a>   
                      </li>
                      <li class="nav-item">
                        <a class="dropdown-item" v-on:click="removeClass()" href="#leb">Leb</a>  
                      </li>
                      <li class="nav-item">
                        <a class="dropdown-item" v-on:click="removeClass()"  href="#destaques">Destaques da obra</a>  
                      </li>
                      <li class="nav-item">
                        <a class="dropdown-item"  v-on:click="removeClass()" href="#autoras">Autora</a>
                      </li>
                      <li class="nav-item">
                          <a class="dropdown-item bold"  v-on:click="removeClass()" href="#contato">Contato</a> 
                      </li>
                      <li class="nav-item">
                      <div class="menu-social">
                      <div class="d-inline socials">
                          <a href="https://www.facebook.com/editoradobrasil/" target="_blank"><img src="../assets/icons/facebook-square-brands.png" class="img-fluid"></a>
                      </div>
                      <div class="d-inline socials">
                          <a href="https://www.instagram.com/editoradobrasil_oficial/" target="_blank"><img src="../assets/icons/instagram-brands.png" class="img-fluid"></a>
                      </div>
                      <div class="d-inline socials">
                          <a href="https://www.youtube.com/user/EditoradoBrasil/" target="_blank"><img src="../assets/icons/youtube-brands.png" class="img-fluid"></a>
                      </div>
                      <div class="d-inline socials">
                          <a href="https://lojavirtual.editoradobrasil.com.br/" target="_blank"><img src="../assets/icons/shopping-cart-solid.png" class="img-fluid"></a>
                      </div>
                  </div>
                  </li>
                  </ul>                            
              </div>
              <div class="collapse navbar-collapse margin-login" id="menu-login">
                  <ul class="navbar-nav mr-auto">
                      <li class="nav-item bold">
                          <a class="nav-link" target="_blank" href="https://www.editoradobrasil.com.br/sistemas/cadastro">Cadastre-se</a>
                      </li>
                      <li class="nav-item bold">
                          <a class="nav-link" target="_blank" href="https://editoradobrasil.com.br/leb/login">Login</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>      
  </nav> 
  <!--FIM NAV MOBILE -->
  </div>
</template>

<script>
export default {
  name: 'Navbar', 
    methods:{
      removeClass: function () {
        document.querySelector('#menu-mb').classList.remove('show');
    },
    home: function(){
      window.scrollTo(0, 0);
    }
  }
}
</script>